'use client';

import type { SortKey, SortOrder } from '@/lib/transactions/types';
import { SortChips } from '@/components/ui/SortChips';

interface Props {
  value: SortKey;
  order: SortOrder;
  onChange: (value: SortKey) => void;
  onToggleOrder: () => void;
}

const OPTIONS: { value: SortKey; label: string }[] = [
  { value: 'date', label: 'Data' },
  { value: 'amount', label: 'Valor' },
  { value: 'merchant', label: 'A–Z' },
];

export function SortControl({ value, order, onChange, onToggleOrder }: Props) {
  return (
    <div className="flex items-center justify-between gap-3">
      <span className="font-mono text-3xs font-semibold tracking-[0.1em] text-text-tertiary uppercase">
        Ordenar
      </span>
      <SortChips
        ariaLabel="Ordenar lançamentos"
        options={OPTIONS}
        value={value}
        order={order}
        onChange={(next) => (next === value ? onToggleOrder() : onChange(next))}
      />
    </div>
  );
}
